import { createRoot } from 'react-dom/client';
import App from './App';

// scan({
//   enabled: import.meta.env.DEV,
// });

createRoot(document.getElementById('root')!).render(<App />);
